export const sortBySpecificOrder = (sortList, propertyKey) => {
  return (a, b) => {
    return sortList.indexOf(a[propertyKey]) - sortList.indexOf(b[propertyKey]);
  };
};
